import { useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import api from "../lib/api"

const Meta = ({ label, value }) => (
  <div style={metaItem}>
    <span style={metaLabel}>{label}</span>
    <span style={metaValue}>{value ?? "Not detected"}</span>
  </div>
);

export default function UploadPrescription() {
  const navigate = useNavigate()
  const fileInputRef = useRef(null);

  const [preview, setPreview] = useState(null);
  const [originalFile, setOriginalFile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");

  const [uploading, setUploading] = useState(false);

  const owner = localStorage.getItem("userId")

  // ---------- FILE PICK ----------
  const openFilePicker = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setOriginalFile(file);
    setPreview(URL.createObjectURL(file));

    await uploadPrescription(file);
  };

  // ---------- BACKEND OCR ----------
const uploadPrescription = async (file) => {
  setLoading(true);

  const formData = new FormData();
  formData.append("prescription", file);

  try {
    const res = await api.post(
      "/api/prescriptions/upload",
      formData
      // ❌ NO HEADERS HERE
    );

    setResult(res.data);
  } catch (err) {
    console.error("Upload failed", err);
    alert("Failed to analyze prescription");
  } finally {
    setLoading(false);
  }
};


  // ---------- CLOUDINARY ----------
  const uploadToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "profile_preset");

    setUploading(true);

    try {
      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dp09q5por/auto/upload",
        {
          method: "POST",
          body: data,
        }
      );

      const json = await res.json();

      if (!json.secure_url) {
        throw new Error("Cloudinary upload failed");
      }

      return json.secure_url;
    } finally {
      setUploading(false);
    }
  };

  // ---------- SAVE FLOW ----------
  const handleSave = async () => {
  if (!title || !originalFile || !result) return;

  try {
    const imageUrl = await uploadToCloudinary(originalFile);

    await api.post("/api/prescription/save", {
      title,
      imageUrl,
      owner,
      analysis: result.analysis,
      requiresPharmacistReview: result.requiresPharmacistReview,
    });

    alert("Prescription saved successfully");
    setShowModal(false);
    setTitle("");
  } catch (err) {
    console.error(err); 
    alert("Failed to save prescription");
  }
};


  return (
  <div style={containerStyle}>
    <div style={headerStyle}>
      <div style = {{display : "flex", alignContent : "center", alignItems : "center"}}>
           <i 
          className="fi fi-br-angle-left"
          onClick={() => navigate(-1)}
      
          style={  {
    cursor: 'pointer',
  
    borderRadius: '50%',

    fontSize: '20px',
  }}
        ></i>
      <h2 style={titleStyle}>Upload Prescription</h2>
      </div>
      <p style={subtitleStyle}>
        Scan or upload a prescription for AI-assisted analysis
      </p>
    </div>

    <div style={{display : "flex"}}>

    <button
      onClick={openFilePicker}
      disabled={loading}
      style={primaryButton}
    >
      {loading ? "Analyzing..." : " Scan Prescription"}
    </button>

    <input
      type="file"
      accept="image/*"
      capture="environment"
      ref={fileInputRef}
      hidden
      onChange={handleFileChange}
    />

     <button
      onClick={openFilePicker}
      disabled={loading}
      style={primaryButton}
    >
      {loading ? "Analyzing..." : "  Upload Prescription"}
    </button>

    <input
      type="file"
      accept="image/*"
     
      ref={fileInputRef}
      hidden
      onChange={handleFileChange}
    />
</div>
    {preview && (
      <div style={imageCard}>
        <img src={preview} alt="Prescription" style={imageStyle} />
      </div>
    )}

    {result && (
      <div style={analysisCard}>
        <h3 style={sectionTitle}>AI Analysis</h3>

        {result.requiresPharmacistReview && (
          <div style={warningBanner}>
            ⚠️ Pharmacist review required
          </div>
        )}

        <div style={metaGrid}>
          <Meta label="Doctor" value={result.analysis.doctor} />
          <Meta label="Clinic" value={result.analysis.clinic} />
          <Meta label="Date" value={result.analysis.date} />
        </div>

        <h4 style={sectionTitle}>Medicines</h4>

        {result.analysis.medicines.map((med, i) => (
          <div key={i} style={medicineCard}>
            <p><strong>{med.name}</strong></p>
            <p>{med.strength}</p>
            <p>{med.frequency}</p>
            <p>{med.duration}</p>
          </div>
        ))}

        {result.analysis.warnings.length > 0 && (
          <>
            <h4 style={sectionTitle}>Warnings</h4>
            {result.analysis.warnings.map((w, i) => (
              <div key={i} style={warningText}>⚠️ {w}</div>
            ))}
          </>
        )}

        <button
          style={secondaryButton}
          onClick={() => setShowModal(true)}
        >
          Save Prescription
        </button>
      </div>
    )}

    {showModal && (
      <div style={overlayStyle}>
        <div style={bottomSheet}>
          <h3 style={{ marginBottom: 10 }}>Save Prescription</h3>

          <input
            type="text"
            placeholder="Prescription title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={inputStyle}
          />

          <button
            onClick={handleSave}
            disabled={uploading || !title}
            style={primaryButton}
          >
            {uploading ? "Saving..." : "Save"}
          </button>

          <button
            onClick={() => setShowModal(false)}
            style={ghostButton}
          >
            Cancel
          </button>

          <p style={disclaimer}>
            AI-assisted analysis. Final verification by a licensed pharmacist
            is required.
          </p>
        </div>
      </div>
    )}
  </div>
);

}



/* ---------- STYLES ---------- */

const containerStyle = {
  padding: 16,
  maxWidth: 420,
  margin: "0 auto",
  fontFamily: "system-ui, -apple-system, sans-serif",
};

const headerStyle = {
  marginBottom: 20,
};

const titleStyle = {
  margin: 0,
  fontSize: 29,
  fontWeight: 700,
  marginLeft : "10px"
};

const subtitleStyle = {
  marginTop: 6,
  fontSize: 12,
  color: "#64748b",
  marginLeft : "30px"
};

const primaryButton = {
  width: "100%",
  padding: "14px 16px",
  borderRadius: 12,
  border: "none",
  background: "var(--primary)",
  color: "#fff",
  fontSize: 16,
  fontWeight: 600,
};

const secondaryButton = {
  marginTop: 16,
  width: "100%",
  padding: 14,
  borderRadius: 12,
  background: "#e2e8f0",
  border: "none",
  fontWeight: 600,
};

const ghostButton = {
  marginTop: 10,
  background: "transparent",
  border: "none",
  color: "#504769",
};

const imageCard = {
  marginTop: 16,
  background: "#fff",
  borderRadius: 16,
  padding: 10,
  boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
};

const imageStyle = {
  width: "100%",
  borderRadius: 12,
};

const analysisCard = {
  marginTop: 20,
  background: "#fff",
  borderRadius: 20,
  padding: 16,
  boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
};

const sectionTitle = {
  marginTop: 16,
  marginBottom: 8,
  fontSize: 16,
  fontWeight: 600,
};

const medicineCard = {
  background: "#f8fafc",
  borderRadius: 12,
  padding: 12,
  marginBottom: 10,
};

const warningBanner = {
  background: "#fff7ed",
  color: "#c2410c",
  padding: 10,
  borderRadius: 10,
  fontWeight: 600,
};

const warningText = {
  color: "#c2410c",
  fontSize: 14,
  marginBottom: 6,
};

const metaGrid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 12,
  marginTop: 12,
};

const metaItem = {
  background: "#f1f5f9",
  padding: 10,
  borderRadius: 10,
};

const metaLabel = {
  fontSize: 12,
  color: "#64748b",
};

const metaValue = {
  fontSize: 14,
  fontWeight: 600,
};

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "flex-end",
};

const bottomSheet = {
  width: "100%",
  background: "#fff",
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  padding: 20,
};

const inputStyle = {
  width: "100%",
  padding: 14,
  borderRadius: 12,
  border: "1px solid #e2e8f0",
  marginBottom: 12,
};

const disclaimer = {
  fontSize: 12,
  color: "#64748b",
  marginTop: 12,
};
